// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9x5PZ","header":"styles_header__f7ODL","spinnerWrapper":"styles_spinnerWrapper__5rHhp","cardContainer":"styles_cardContainer__Kyd9B"};